import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { use, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useModal } from "./useModal";
import { corporateStructureApiFactory } from "../apiFactory/corporateStructureApiFactory";
import useCountries from "./useCountries";
import useRegulatoryBody from "./useRegulatoryBody";
import { ClientCounterpartyFactory } from "../factory/clientCoutnerpartyFactory";
import { corporateStructureService } from "../requests/corporateStructureService";
import { requestService } from "../requests/requestService";
import { managementStructureService } from "../requests/managementStrcutureService";

import { clientCoutnerpartyService } from "../requests/clientCounterpartyService";
import useExchanges from "./useExchanges";
import useCompanyType from "./useCompanyType";
import { ManagementStructureFactory } from "../factory/managementStrcutureFactory";
import config from "../config/config";
import { utilityService } from "../requests/utilityService";
import { ClientCounterpartyApiFactory } from "../apiFactory/clientCounterpartyApiFactory";
import {userSession} from "../observers/userObserver";
import { sharedData } from "../sharedData/sharedData";
import { AlreadyValidated, ValidatedSuccessfully, SavedSuccessfully, UpdatedSuccessfully, Saving, SkipSaving } from "../components/popups/popupMessages";

import { useValidateClientCounterParty } from "../validations/validationHooks/useValidateClientCounterparty";
import { createPrivateEvent } from "../utils/utils";
import { matchCompanyType } from "../utils/matchCompanyType";
import { useDiligence } from "./useDeligence";
import { diligenceTypeObservable } from "../observers/Observable";
import { diligenceObservable } from "../observers/deligenceObservable";
import { handleAddressValidationNonUbo } from './addressValidator';
import { useValidateSingleAddress } from "../hooks/validateSingleAddress";
import { CorporateStructureFactory } from "../factory/corporateStructureFactory";
import { getNextEnabledSection } from "../utils/navigationHelper";
import { reloadAfterValidate } from "../utils/reloadAfterValidate";
// import { CorporateStructureFactory } from "../factory/corporateStructureFactory";

export const useClientCounterpartyData = () => {
  const localStorageKey = "clientFormData";
  const ownerId = "Client/Counterparty";

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [modalHeading, setModalHeading] = useState("");
  const [step, setStep] = useState(1);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [iscompliantLetter, setiscompliantLetter] = useState(false);


  const requestId = useMemo(() => { return sharedData.get("requestId") }, []);
  const transactionId = useMemo(() => { return sharedData.get("transactionId") }, []);
  const propertyId = useMemo(() => { return sharedData.get("propertyId") }, []);
  const transactionType = useMemo(() => { return sharedData.get("transactionType") }, []);


  const [diligenceType, setDiligenceType] = useState("");
  const [isCompliant, setIsCompliant] = useState(false);
  const { modalOpen, modalMessage, setModalOpen, setModalMessage } = useModal();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(searchParams.get('readonly') === 'true');
  const [selectedOption, setSelectedOption] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(() => {
    const savedFormData = localStorage.getItem(localStorageKey);
    return savedFormData ? JSON.parse(savedFormData) : ClientCounterpartyFactory({});
  });
  const [companyType, setCompanyType] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isEntityListed, setIsEntityListed] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({ clientType: "", entityType: "" });
  const [isRegulatoryListed, setIsRegulatoryListed] = useState(false);
  const [isBillingEntityListed, setIsBillingEntityListed] = useState(false);
  const [compliantLetter, setCompliantLetter] = useState("");
  const [relianceFromThirdParty, setRelianceFromThirdParty] = useState("");
  const [existingEntity, setExistingEntity] = useState([]);
  const countries = useCountries();
  const exchanges = useExchanges();
  const regulatoryBodies = useRegulatoryBody(formData.countryOfIncorporation);
  const companyTypes = useCompanyType(formData.countryOfIncorporation);
  const [isSelectorReadOnly, setIsSelectorReadOnly] = useState(searchParams.get("readonly") === "true");
  const {errors, validateClientCounterParty} = useValidateClientCounterParty();

  // When companyTypes loads from the API, normalise any raw Companies House code
  // stored in DB (e.g. "ltd" → "Limited Company (Ltd)") so the dropdown shows correctly.
  useEffect(() => {
    if (!companyTypes || companyTypes.length === 0) return;
    if (!formData.companyType) return;

    const isAlreadyValid = companyTypes.some(
      (ct) => ct.CompanyType === formData.companyType
    );
    if (isAlreadyValid) return;

    const matched = matchCompanyType(formData.companyType, companyTypes);
    if (matched) {
      const event = { target: { name: "companyType", value: matched } };
      updateFormData(event);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyTypes]);
  const { currentStatus, setDiligenceStatus } = useDiligence("Client/CounterParty");
  // const [diligenceOwner, setDiligenceOwner] = useState(ownerId);

  const viewMode = searchParams.get('view') === 'true'
  const editMode = searchParams.get('edit') === 'true'

  const { validateSingleAddress } = useValidateSingleAddress();
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [pendingUpdatedData, setPendingUpdatedData] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
const [loadingMessage, setLoadingMessage] = useState('');
const showLoader = (message) => {
  setLoadingMessage(message);
  setIsLoading(true);
};

const hideLoader = () => {
  setIsLoading(false);
  setLoadingMessage('');
};
  const checkIsReadOnly = useCallback((detail) => {
    console.log(detail);
    if (!detail) return false; // Guard against undefined detail object
    const isEditMode = searchParams.get("edit") === "true";
    const isTransactionCompleted = detail.entityStatus === "Validated";
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    setIsReadOnly(isTransactionCompleted || isReadOnlyFromURL || isViewMode)
    return isTransactionCompleted || isReadOnlyFromURL || isViewMode;
  }, [searchParams])

  // Load from local storage
  useEffect(() => {
    const savedFormData = localStorage.getItem(localStorageKey);
    if (savedFormData) {
      const parsedFormData = JSON.parse(savedFormData);
      setFormData(parsedFormData);
      setSelectedCountry(parsedFormData.countryOfIncorporation);
    }
  }, []);

  useEffect(() => {
    if (requestId) {
      clientCoutnerpartyService.fetchEntityByRequestId(requestId)
        .then((entityId) => {
          setExistingEntity(entityId);
        })
        .catch((error) => {
          console.error("Error fetching properties:", error);
        })
    }
  },
    [requestId]);


  

  const getEntityDetailsByEntityId = useCallback(async (entityId) => {
    if (entityId !== "None") {
      const entityDetail = await clientCoutnerpartyService.fetchEntityDetailsByEntityId(entityId);
      if (entityDetail && entityDetail.details) {
        const formData = ClientCounterpartyFactory(entityId, entityDetail.details);
        setFormData(formData);
        localStorage.setItem(localStorageKey, JSON.stringify(formData));
        const isReadOnly = checkIsReadOnly(formData);
        console.log("isReadOnly ? ", isReadOnly);
        setIsReadOnly(isReadOnly);
        setIsDisabled(isReadOnly);
      } else {
        setFormData({});
        const isReadOnlyFromURL = searchParams.get("readonly") === "true" || searchParams.get("view") === "true";
        setIsReadOnly(isReadOnlyFromURL);
        setIsDisabled(false);
      }
    }
  }, [checkIsReadOnly, searchParams]);



  const getQuickCorporateStrucutureByEntityId = useCallback(async (entityId) => {
      try {
        const response = await corporateStructureService.getQuickCorporateStructure(entityId);
        if (response.ok) {
          const data = CorporateStructureFactory(response.data);  
          localStorage.setItem("corporateFormData", JSON.stringify(data));
        } else {
          console.error("Failed to fetch corporate structure data:", response.data);
        }
      } catch (error) {
       
        console.error("Error fetching corporate structure data:", error);
      }
    },[]);


    const sendCorporate = async (entityId, requestId) => {
      try {
        // ✅ Step 1: Retrieve data from localStorage
        const storedData = localStorage.getItem("corporateFormData");
    
        if (!storedData) {
          console.error("❌ No corporateFormData found in localStorage.");
          return;
        }
    
        // ✅ Step 2: Parse the JSON
        const parsedData = JSON.parse(storedData);
    
        // ✅ Step 3: Build the payload using your API factory
        // status is stripped on purpose: this copies the selected counterparty's
        // structure onto the entity, it does not decide Corporate Structure's
        // validation. Only that section's own Validate button may. The cached value
        // here is whatever the last fetch left behind, and posting it back is what
        // silently un-validated a signed-off section.
        const payload = corporateStructureApiFactory(requestId, entityId, {
          ...parsedData,
          status: undefined,
          entityId: entityId  // ensure entityId is updated
        });
    
        console.log("✅ Payload ready to send:", payload);
    
        // ✅ Step 4: Send the payload
        const response = await corporateStructureService.saveCorporateStructure(payload);
    
        if (response.ok) {
          console.log("✅ Corporate structure data sent successfully:", response.data);
        } else {
          console.error("❌ Failed to save corporate structure:", response.data);
        }
      } catch (error) {
        console.error("❌ Error sending corporate structure data:", error);
      }
    };
  

  const getQuickEntityDetailsByEntityId = useCallback(async (entityId) => {
    if (entityId !== "None") {
      const entityDetail = await clientCoutnerpartyService.fetchQuickEntityDetailsByEntityId(entityId);
      if (entityDetail && entityDetail.details) {
        const formData = ClientCounterpartyFactory(undefined,entityDetail.details);
        setFormData(formData);
        localStorage.setItem(localStorageKey, JSON.stringify(formData));
        const isReadOnly = checkIsReadOnly(formData);
        console.log("isReadOnly ? ", isReadOnly);
        setIsReadOnly(isReadOnly);
        setIsDisabled(isReadOnly);
      } else {
        setFormData({});
        const isReadOnlyFromURL = searchParams.get("readonly") === "true" || searchParams.get("view") === "true";
        setIsReadOnly(isReadOnlyFromURL);
        setIsDisabled(false);
      }
    }
  }, [checkIsReadOnly, searchParams]);











  useEffect(() => {
    if (viewMode || editMode) {
      getEntityDetailsByEntityId(sharedData.get("entityId"))
    }
  }, [getEntityDetailsByEntityId, viewMode, editMode]);

  // Show warning modal immediately when Counterparty is selected without Transaction/Property
  useEffect(() => {
    if (formData.entityType === "Counterparty") {
      const transactionId = sharedData.get("transactionId");
      const propertyId = sharedData.get("propertyId");

      const hasTransactionId = transactionId && transactionId !== "" && transactionId !== "None" && transactionId !== 0;
      const hasPropertyId = propertyId && propertyId !== "" && propertyId !== "None" && propertyId !== 0;

      console.log("🔍 Counterparty selected - checking requirements:", {
        transactionId,
        propertyId,
        hasTransactionId,
        hasPropertyId
      });

      if (!hasTransactionId || !hasPropertyId) {
        console.log("⚠️ Showing warning modal for Counterparty selection");
        setModalMessage("Counterparties required Transaction and Property Details");
        setIsModalOpen(true);
      }
    }
  }, [formData.entityType]);




  const updateFormData = useCallback((event) => {
    const { name, value } = event.target;
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [name]: value,
      };
      localStorage.setItem(localStorageKey, JSON.stringify(updatedFormData));
      return updatedFormData;
    });
  }, []);


 
   const updateRequestTable = async () => {
     try {
       if (!requestId) {
        setModalMessage("Request ID is missing. Cannot update request table.");
         return;
       }
       
       // ✅ Get propertyId from localStorage
       const savedData = localStorage.getItem("propertyFormData");
       const entityId = sharedData.get("entityId");
       // BUG: Backend accept transaction id, when passing, throws 500
       const data = {entityId,requestId};
       console.log("Update request payload: ", data);
       const updateResponse = await requestService.updateRequest(data);
       
    
     } catch (error) {
      setModalMessage(` Failed to update request table: ${error.message}`);
     }
   };



  const handleEntityChanged = useCallback(async (event) => {
    console.log("event",event)
    setHasUnsavedChanges(true);
    // sharedData.set("entityId",event.target.value);
    diligenceObservable.remove(ownerId); // remove old deligence status from the list for this owner
    if (event.target.value !== "None") {
      updateFormData(event);
      console.log("updated",updateFormData)
      getQuickEntityDetailsByEntityId(event.target.value);
      getQuickCorporateStrucutureByEntityId(event.target.value);
      getQuickManagementStrcutureDetails(event.target.value);
      fetchRiskAssessment(event.target.value);
      fetchRiskAssessmentContinue(event.target.value);
      fetchEDDData(event.target.value);
      } else {
      setFormData(ClientCounterpartyFactory({}));
      localStorage.setItem("clientFormData",JSON.stringify({}));
      diligenceTypeObservable.revert(ownerId);
    }
  }, [getQuickEntityDetailsByEntityId, ownerId, updateFormData])






  const handleSpecialCases = useCallback((name, value) => {
    if (name === "relianceFromThirdParty") {
      setRelianceFromThirdParty(value);
      if (value === "No") {
        updateFormData(createPrivateEvent("compliantLetter", ""));
        updateFormData(createPrivateEvent("complyWithRegulations", ""));
        updateFormData(createPrivateEvent("entityName", ""));
        updateFormData(createPrivateEvent("regulatoryBodyAutorizedBy", "None"));
      }
    } else if (name === "compliantLetter") {
      setiscompliantLetter(value === "Yes");
      setCompliantLetter(value);
      if (value === "No") {
        updateFormData(createPrivateEvent("complyWithRegulations", ""));
        updateFormData(createPrivateEvent("entityName", ""));
        updateFormData(createPrivateEvent("entityType", ""));
        updateFormData(createPrivateEvent("regulatoryBodyAutorizedBy", "None"));
      }
    } else if (name === "complyWithRegulations") {
      setIsCompliant(value === "Yes");
      if (value === "No") {
        updateFormData(createPrivateEvent("entityName", ""));
        updateFormData(createPrivateEvent("entityType", "None"));
        updateFormData(createPrivateEvent("regulatoryBodyAutorizedBy", "None"));
      }
    } else if (name === "entityId") {
      sharedData.get("entityId");
    } else if (name === "isBillingRecognized") {
      if (value === "No") {
        updateFormData(createPrivateEvent("recognisedExchange", "None"));
      }
    } else if (name === "isRegulatoryListed") {
      if (value === "No") {
        updateFormData(createPrivateEvent("regulatoryBody", "None"));
        updateFormData(createPrivateEvent("regulatoryReferenceNumber", ""));
      }
    }
  }, [updateFormData]);

  // const handleChange = useCallback((event) => {
  //   setHasUnsavedChanges(true);
  //   const { name, value } = event.target;
  //   console.log("Handle Change: ", event.target.name, event.target.value);
  //   updateFormData(event);
  //   handleSpecialCases(name, value);
  // }, [handleSpecialCases, updateFormData])
  const handleChange = useCallback((event) => {
    setHasUnsavedChanges(true);
    const { name, value } = event.target;
    console.log("Handle Change: ", name, value);
    updateFormData(event); // ✅ pass full event
    handleSpecialCases(name, value);
  }, [handleSpecialCases, updateFormData]);

  // Keep regulatory/billing flags in a ref so fetchDiligenceType is reference-stable.
  // Without this, fetchDiligenceType's useCallback re-creates whenever the user toggles
  // those flags, which cascades into the parent useEffect (line below) firing again,
  // wiping the just-set diligence value and creating a 500ms+ window where sharedData
  // has no diligence — causing Save+Next to mis-route to /corporate-structure.
  const overrideFlagsRef = useRef({ isRegulatoryListed: "No", isBillingEntityListed: "No" });
  useEffect(() => {
    overrideFlagsRef.current = {
      isRegulatoryListed: formData.isRegulatoryListed,
      isBillingEntityListed: formData.isBillingEntityListed || formData.isBillingRecognized,
    };
  }, [formData.isRegulatoryListed, formData.isBillingEntityListed, formData.isBillingRecognized]);

  const fetchDiligenceType = useCallback(async (country, companyType) => {
    if (
      !country || !companyType ||
      country === "None" || companyType === "None" ||
      country === "" || companyType === ""
    ) {
      diligenceObservable.remove(ownerId);
      return;
    }

    try {
      // Check if current status is Enhanced - if so, don't change it
      const currentDiligenceStatus = diligenceObservable.getValue(ownerId);
      if (currentDiligenceStatus && currentDiligenceStatus.value?.toLowerCase() === "enhanced") {
        console.log("🔒 Diligence status is Enhanced - cannot be changed");
        return;
      }

      const diligence = await clientCoutnerpartyService.getDiligenceType(companyType, country);

      let finalDiligenceType = diligence;

      // Override to Simplified if conditions are met (read flags from ref so this
      // callback stays reference-stable across regulatory/billing toggles)
      const flags = overrideFlagsRef.current;
      if (
        diligence === "Standard" &&
        (flags.isRegulatoryListed === "Yes" || flags.isBillingEntityListed === "Yes")
      ) {
        finalDiligenceType = "Simplified";
      }

      diligenceObservable.setValue(finalDiligenceType, ownerId);
      console.log(`✅ Diligence type updated to: ${finalDiligenceType} (API response: ${diligence})`);
    } catch (err) {
      console.error("❌ Error fetching diligence type:", err);
      diligenceObservable.remove(ownerId);
    }
  }, []);   // stable: reads override flags from ref instead of formData
  
















  useEffect(()=>{
    // Don't remove() here — that creates a 500ms window where sharedData has no
    // diligence, during which Save+Next mis-routes. fetchDiligenceType replaces
    // the value atomically when its API call settles.
    const timeoutId = setTimeout(() => {
      fetchDiligenceType(formData.countryOfIncorporation, formData.companyType);
    }, 500); // debounce
    return () => clearTimeout(timeoutId);
  },[formData.countryOfIncorporation, formData.companyType, fetchDiligenceType])


  useEffect(() => {
    const privateEvent = { target: { name: "countryType", value: "None" } };
    updateFormData(privateEvent);
  }, [formData.countryOfIncorporation, updateFormData])

  // Function to re-evaluate diligence status with specific regulatory/billing values
  const reEvaluateDiligenceStatusWithValues = useCallback((isRegulatory, isBilling) => {
    // Only re-evaluate if we have the required data and status is not Enhanced
    if (formData.countryOfIncorporation && formData.companyType &&
        formData.countryOfIncorporation !== "None" && formData.companyType !== "None") {

      const currentDiligenceStatus = diligenceObservable.getValue(ownerId);

      // Don't change if Enhanced
      if (currentDiligenceStatus && currentDiligenceStatus.value?.toLowerCase() === "enhanced") {
        console.log("🔒 Cannot re-evaluate: Diligence status is Enhanced");
        return;
      }

      // Check if conditions now require Simplified
      const shouldBeSimplified = (isRegulatory || isBilling);

      console.log(`🔍 Re-evaluating diligence: isRegulatory=${isRegulatory}, isBilling=${isBilling}, shouldBeSimplified=${shouldBeSimplified}`);
      console.log(`Current status: ${currentDiligenceStatus?.value || 'None'}`);

      if (shouldBeSimplified) {
        // If current status is Standard or not set, change to Simplified
        if (!currentDiligenceStatus || currentDiligenceStatus.value?.toLowerCase() === "standard") {
          console.log("✅ Changing Standard → Simplified due to regulatory/billing conditions");
          diligenceObservable.setValue("Simplified", ownerId);
        }
      } else {
        // If conditions no longer require Simplified, fetch the original status
        console.log("↩️ Conditions no longer require Simplified, fetching original status");
        // Remove current status and refetch
        diligenceObservable.remove(ownerId);
        setTimeout(() => {
          fetchDiligenceType(formData.countryOfIncorporation, formData.companyType);
        }, 100);
      }
    }
  }, [formData.countryOfIncorporation, formData.companyType, fetchDiligenceType, ownerId]);

  // Function to re-evaluate diligence status when regulatory/billing conditions change
  const reEvaluateDiligenceStatus = useCallback(() => {
    reEvaluateDiligenceStatusWithValues(formData.isRegulatoryListed === "Yes", (formData.isBillingEntityListed || formData.isBillingRecognized) === "Yes");
  }, [formData.isRegulatoryListed, formData.isBillingEntityListed, formData.isBillingRecognized, reEvaluateDiligenceStatusWithValues]);

  const handleRegulatoryChange = useCallback((event) => {
    const newValue = event.target.value === "Yes";
    console.log("🔄 Regulatory Change: ", event.target.name, event.target.value, "newValue:", newValue);

    updateFormData(event);
    setIsRegulatoryListed(newValue);

    handleSpecialCases(event.target.name, event.target.value);

    // Re-evaluate immediately with the new value
    console.log("🚀 Calling reEvaluateDiligenceStatusWithValues with:", newValue, isBillingEntityListed);
    reEvaluateDiligenceStatusWithValues(newValue, isBillingEntityListed);

  }, [handleSpecialCases, updateFormData, isBillingEntityListed, reEvaluateDiligenceStatusWithValues])

  const handleBillingEntityChange = useCallback((event) => {
    const newValue = event.target.value === "Yes";
    console.log("🔄 Billing Entity Change: ", event.target.name, event.target.value, "newValue:", newValue);

    updateFormData(event);
    setIsBillingEntityListed(newValue);

    handleSpecialCases(event.target.name, event.target.value);

    // Re-evaluate immediately with the new value
    console.log("🚀 Calling reEvaluateDiligenceStatusWithValues with:", isRegulatoryListed, newValue);
    reEvaluateDiligenceStatusWithValues(isRegulatoryListed, newValue);

  }, [handleSpecialCases, updateFormData, isRegulatoryListed, reEvaluateDiligenceStatusWithValues])

  const handleentityChange = useCallback((event) => {
    updateFormData(event);
    setIsEntityListed(event.target.value === "Yes");
    handleSpecialCases(event.target.name, event.target.value);
  }, [handleSpecialCases, updateFormData])

  const handleMoneyChange = useCallback((event) => {
    updateFormData(event);
    handleSpecialCases(event.target.name, event.target.value);
    setSelectedOption(event.target.value);
  }, [handleSpecialCases, updateFormData])

  const handleCountryChange = useCallback(async (event) => {
    setHasUnsavedChanges(true);
    updateFormData(event);
    setSelectedCountry(event.target.value);
  }, [updateFormData])

  const updateRequestPendingAction = useCallback(async (requestId) => {
    const payload = {
      requestId: requestId,
      action: "Yes",
    };
  
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/updateRequestPendingAction`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json" // ✅ Required for JSON body
        },
        body: JSON.stringify(payload) // ✅ Send the actual payload
      });
  
      const data = await response.json();
  
      if (response.ok) {
        console.log("Update successful:", data);
       
      } else {
        console.error("Failed to update pending action:", data);
      }
    } catch (error) {
      console.error("Error during updateRequestPendingAction:", error);
    }
  }, []);





  const sendMail = useCallback(async (userType) => { 
    showLoader('Sending email, please wait...');
    const payload = {
      requestId: requestId,
      userType: userType
    };
  
    try {
      // 1️⃣ Call the email sending API
      const data = await utilityService.sendMail(payload);
  
      // 2️⃣ Then call updateRequestPendingAction
      if (data) {
        await updateRequestPendingAction(requestId);  // ⬅️ Calling your function here
        setModalMessage(`${userType.toUpperCase()} has been notified.`);
        setModalOpen(true);
      } else {
        console.log("Data is null in sendMail");
      }
    } catch (error) {
      console.error("❌ Error in sendMail:", error);
    }
    hideLoader();
  }, [requestId, setModalMessage, setModalOpen, updateRequestPendingAction]);
  








  const updateEntity = useCallback(async (payload, requestId) => {
    try {
      console.log("Fresh requestId:", requestId); // Log to confirm requestId is being passed
      console.log("Payload:", payload); // Log the payload to verify

      if (!requestId) {
        throw new Error("requestId is required and should be valid.");
      }

      const response = await clientCoutnerpartyService.updateEntity(requestId, payload)
      return response;

    } catch (error) {
      console.error("Error with the fetch operation:", error);
    }
  }, [])



  useEffect(() => {
    console.log("🧪 isRegulatoryListed updated →", isRegulatoryListed);
  }, [isRegulatoryListed]);



 const getQuickManagementStrcutureDetails = useCallback(async (entityId) => {
     try {
       const response = await managementStructureService.getQuickManagementStrcutureByEntityId(entityId);
       if (response.ok) {
         const data = response.data;
         // console.log("Data: ", data[0].data);
         const managersData = ManagementStructureFactory(data[0].data);
         
         
         // No 'managersStatus' — the key is gone. It was global rather than per-request,
         // so it carried another deal's status across, and nothing writes a status this
         // page does not own. Management Structure now reads its own from the server.
         localStorage.setItem('managers', JSON.stringify(managersData));
       } else if (response.status === 404) {
           // setModalMessage("Management structure not found for this entity, You can add a new one.")
           // setIsModalOpen(true);
       } else {
         console.error("Failed to fetch management structure data:", response.data);
       }
     } catch (error) {
       console.error("Error fetching management structure details:", error);
     }
   },[]);
  

   const sendManagement = async (entityId, requestId) => {
    try {
      // ✅ Step 1: Retrieve data from localStorage
      const storedData = localStorage.getItem("managers");

      if (!storedData) {
        console.error("❌ No managers data found in localStorage.");
        return;
      }
  
      // ✅ Step 2: Parse the JSON
      const parsedData = JSON.parse(storedData);
  
      // ✅ Step 3: Build the payload
      // No `status`. This copies the selected counterparty's managers onto the entity —
      // it does not decide whether Management Structure is validated, and only that
      // section's own Validate button may. Sending a cached status from here is what
      // silently un-validated sections a user or the MLNO had already signed off.
      const payload = {
        entityId: entityId,
        requestId: requestId,
        data: JSON.stringify(parsedData),
      };
  
      console.log("✅ Management Structure Payload ready to send:", payload);
  
      // ✅ Step 4: Send the payload
      const response = await managementStructureService.saveManagementStructure(payload);
  
      if (response.ok) {
        console.log("✅ Management structure data sent successfully:", response.data);
      } else {
        console.error("❌ Failed to save management structure:", response.data);
      }
    } catch (error) {
      console.error("❌ Error sending management structure data:", error);
    }
  };




  const fetchRiskAssessmentContinue = useCallback(async (entityId) => {
    if (!entityId) {
      console.warn("⚠️ Entity ID is missing, skipping fetch.");
      return;
    }
  
    try {
      const token = userSession.getToken(); // Use consistent token handling
      const response = await fetch(`${config["backend-url"]}/get_quick_risk_assessment_continued`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ entityId }),
      });
  
      if (!response.ok) {
        console.error("❌ Failed to fetch risk assessment continued data:", response.statusText);
      
      }
  
      const data = await response.json();
      localStorage.setItem("riskFormDataContinued", JSON.stringify(data));
  
    
      console.log("✅ Risk Assessment Continued data fetched and stored.");
    } catch (err) {
      console.error("❌ Error fetching risk assessment continued data:", err.message);
    }
  }, []);
  



  const fetchEDDData = async (entityId) => {
    if (!entityId) {
      console.warn("⚠️ Entity ID is missing, skipping fetch.");
      return;
    }
  
    try {
      const response = await fetch(`${config["backend-url"]}/get_quick_edd`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
          "Authorization": `Bearer ${userSession.getToken()}`
         },
        body: JSON.stringify({ entityId })
      });
  
      const data = await response.json();
  
      if (response.ok && data.edd_data) {
        // ✅ Save to localStorage
        localStorage.setItem("EDDFormData", JSON.stringify(data.edd_data));
  
      
  
        console.log("✅ EDD data fetched and stored successfully.");
      } else {
        console.warn("⚠️ EDD data not found or response not ok:", data);
      }
    } catch (error) {
      console.error("❌ Failed to fetch EDD data:", error);
    }
  };
  
  const SaveEdd = async (entityId) => {
    console.log("EDD Save initiated");
  
    try {
      const storedData = localStorage.getItem("EDDFormData");
      let payload;
  
      if (storedData) {
        // ✅ Use data from localStorage if available
        payload = {
          ...JSON.parse(storedData),
          entityId: entityId
        };
      } else {
        console.warn("❌ EDD Form Data not found in localStorage.");
        return; // ✅ Exit if no payload is found
      }
  
      console.log("✅ EDD Save Payload:", payload);
  
      const response = await fetch(`${config["backend-url"]}/save_edd`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userSession.getToken()}`
        },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        console.log("✅ EDD data saved successfully.");
      } else {
        const error = await response.json();
        console.error("❌ Failed to save EDD data:", error);
      }
    } catch (error) {
      console.error('❌ Error saving data:', error);
    }
  };
  
  


  const fetchRiskAssessment = async (entityId) => {
    try {
      const token = userSession.getToken();
      console.log("🔄 Fetching risk assessment for Entity ID:", entityId);
  
      const response = await fetch(`${config["backend-url"]}/get_Quick_risk_assessment`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ entityId })  // ✅ entityId sent in request body
      });
  
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Failed to fetch risk assessment");
      }
  
      const riskData = await response.json();
  
      // ✅ Store in localStorage
      localStorage.setItem("riskFormData", JSON.stringify(riskData));
      console.log("✅ Risk assessment data saved to localStorage:", riskData);
      
  
  
      return riskData;
  
    } catch (error) {
      console.error("❌ Error fetching risk assessment:", error.message);
    }
  };




  const saveRiskAssessmentContinued = useCallback(
    async (entityId) => {
      try {
        // ✅ Step 1: Retrieve risk continued data from localStorage
        const storedData = localStorage.getItem("riskFormDataContinued");
        if (!storedData) {
          console.error("❌ No riskFormDataContinued found in localStorage.");
          return;
        }
  
        const riskData = JSON.parse(storedData);
  
        // ✅ Step 2: Build the payload
        const payload = {
          ...riskData,
          entityId: entityId
        };
  
        console.log("✅ Risk Assessment Continued Payload ready to send:", payload);
  
        // ✅ Step 3: Send the data
        const response = await fetch(`${config["backend-url"]}/save_risk_assessment_continued`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`
          },
          body: JSON.stringify(payload)
        });
  
        if (!response.ok) {
          const error = await response.json();
          console.error("❌ Failed to save risk assessment continued:", error);
        }
      } catch (error) {
        console.error("❌ Error saving risk assessment continued:", error.message);
      }
    },
    [] // Dependencies
  );
  

  const sendRiskAssessment = async (entityId) => {
    try {
      // ✅ Step 1: Retrieve risk data from localStorage
      const storedData = localStorage.getItem("riskFormData");
      if (!storedData) {
        console.error("❌ No riskFormData found in localStorage.");
        return;
      }
  
      // ✅ Step 2: Parse the data
      const riskData = JSON.parse(storedData);
  
      // ✅ Step 3: Build the payload
      const payload = {
        ...riskData,
        entityId: entityId
      };
  
      console.log("✅ Risk Assessment Payload ready to send:", payload);
  
      // ✅ Step 4: Send the data
      const response = await fetch(`${config["backend-url"]}/save_risk_assessment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${userSession.getToken()}`
        },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        console.log("✅ Risk Assessment saved successfully.");
      } else {
        const errorData = await response.json();
        console.error("❌ Failed to save risk assessment:", errorData);
      }
    } catch (error) {
      console.error("❌ Error saving risk assessment:", error);
    }
  };
  



  // const handleUpdate = useCallback(async (event) => {
  //   setHasUnsavedChanges(false);
  //   if (formData.status === "Validated") { 
  //     setModalMessage(<SkipSaving page={"Client CounterParty"} />); 
  //     setIsModalOpen(true); 
  //     setHasUnsavedChanges(false);
  //     // event.preventDefault();
  //     await updateRequestTable(); // ✅ Call update request table API
      
      
  //     return; 

    
    
  //   }


    

  //   if (!requestId) {
  //     setModalMessage(
  //       <>
  //         <strong>Request ID is missing. Cannot update entity.</strong>
  //       </>
  //     );
  //     setIsModalOpen(true);
  //     return;
  //   }

  //   setLoading(true);
  //   const payload = ClientCounterpartyApiFactory(formData);
  //   console.log("Payload for handleUpdate: ", payload);

  //   try {
  //     const payload = ClientCounterpartyApiFactory(formData);
  //     console.log("Payload for handleUpdate: ", payload);

  //     const response = await updateEntity(payload, requestId);

  //     if (response.ok) {
  //       sharedData.set("entityId", response.data.entityId);
  //       getEntityDetailsByEntityId(response.data.entityId)

  //       setModalMessage(<SavedSuccessfully page={"Client CounterParty"} />);
  //       setIsModalOpen(true);

  //     } else {
  //       setModalMessage(
  //         <>
  //           <strong>Error: ${JSON.stringify(response.data) || "Failed to update entity"}</strong>
  //         </>
  //       );
  //       setIsModalOpen(true)
  //     }
  //   } catch (error) {
  //     console.error("Error updating entity details ...");
  //     setModalMessage(
  //       <>
  //         <strong>Error: ${error.message || "Failed to update entity"}</strong>
  //       </>
  //     );
  //     setIsModalOpen(true)
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [formData, getEntityDetailsByEntityId, requestId, setModalMessage, updateEntity])





  const handleUpdate = useCallback(async (event) => {
    setHasUnsavedChanges(false);
  
    if (formData.status === "Validated") {
      setModalMessage(<SkipSaving page={"Client CounterParty"} />);
      setIsModalOpen(true);
      await updateRequestTable(); // ✅ Call update request table API
      return;
    }
  
    if (!requestId) {
      setModalMessage(
        <>
          <strong>Request ID is missing. Cannot update entity.</strong>
        </>
      );
      setIsModalOpen(true);
      return;
    }
  
    setLoading(true);
  
    try {
      const payload = ClientCounterpartyApiFactory(formData);
      console.log("Payload for handleUpdate:", payload);
  
      const response = await updateEntity(payload, requestId);
  
      if (response.ok) {
        const newEntityId = response.data.entityId;
        sharedData.set("entityId", newEntityId);
  
        // Fetch entity details
        getEntityDetailsByEntityId(newEntityId);
  
        // ✅ Call sendCorporate and sendManagement
        await sendCorporate(newEntityId, requestId);
        await sendManagement(newEntityId, requestId);
        await sendRiskAssessment(newEntityId);
        await saveRiskAssessmentContinued(newEntityId);
        await SaveEdd(newEntityId);
  
        setModalMessage(<SavedSuccessfully page={"Client CounterParty"} />);
        setIsModalOpen(true);
      } else {
        setModalMessage(
          <>
            <strong>Error: {JSON.stringify(response.data) || "Failed to update entity"}</strong>
          </>
        );
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Error updating entity details ...", error);
      setModalMessage(
        <>
          <strong>Error: {error.message || "Failed to update entity"}</strong>
        </>
      );
      setIsModalOpen(true);
    } finally {
      setLoading(false);
    }
  }, [
    formData,
    getEntityDetailsByEntityId,
    requestId,
    setModalMessage,
    updateEntity,
    sendCorporate,
    sendManagement
  ]);
  

  const handleValidate = useCallback(async (event) => {
    event?.preventDefault?.(); // ✅ Only run if event exists & has preventDefaul
   
    if (!requestId) {
      console.error("❌ Error: requestId is missing!");
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Request ID is missing. Cannot update entity.</strong>
        </>
      );
      setIsModalOpen(true);
      return;
    }
    setLoading(true);
    try {
      const { valid, data: updatedFormData } = await handleAddressValidationNonUbo({
        formData,
        validateSingleAddress,
        setFormData,
        setModalOpen,
        setModalHeading,
        setModalMessage,
        setValidationResult,
        setPendingUpdatedData,
        setShowAddressModal
      });
      const payload = ClientCounterpartyApiFactory({ ...updatedFormData, status: "Validated" });
      const response = await updateEntity(payload, requestId);

      if (response.ok) {
        sharedData.set("entityId", response.data.entityId);
        getEntityDetailsByEntityId(response.data.entityId);
        setModalMessage(
          <>
            <h2 style={{ margin: "10px 0", textAlign: "center" }}>
              Validation Result
            </h2>
            <strong>`Validation Successful</strong>
          </>
        );
        setIsModalOpen(true);
        setHasUnsavedChanges(false);
      } else {
        setModalMessage(
          <>
            <h2 style={{ margin: "10px 0", textAlign: "center" }}>
              Validation Result
            </h2>
            <strong>Error: ${JSON.stringify(response.data) || "Failed to update entity"}</strong>
          </>
        );
        setIsModalOpen(true);
      }
    } catch (error) {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Error: ${error.message || "Failed to update entity"}</strong>
        </>
      );
      setIsModalOpen(true);
    } finally {
      setLoading(false); // ✅ Stop loading state
    }
  }, [formData, getEntityDetailsByEntityId, requestId, setModalMessage, updateEntity])


 
















  const cleanPayload = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined)
    );
  };
  const handleNext = useCallback(async () => {
    // Check if entity role is Counterparty and validate transaction/property requirement
    console.log("🔍 HandleNext - Checking Counterparty validation:", {
      entityType: formData.entityType,
      isCounterparty: formData.entityType === "Counterparty"
    });

    // Make sure diligence is resolved before navigation. The fetchDiligenceType
    // useEffect debounces by 500ms; clicking Next during that window would route
    // to /corporate-structure even when the entity is Simplified.
    if (
      !sharedData.get("diligenceStatus") &&
      formData.countryOfIncorporation && formData.companyType &&
      formData.countryOfIncorporation !== "None" && formData.companyType !== "None"
    ) {
      await fetchDiligenceType(formData.countryOfIncorporation, formData.companyType);
    }

    if (formData.entityType === "Counterparty") {
      const transactionId = sharedData.get("transactionId");
      const propertyId = sharedData.get("propertyId");

      const hasTransactionId = transactionId && transactionId !== "" && transactionId !== "None" && transactionId !== 0;
      const hasPropertyId = propertyId && propertyId !== "" && propertyId !== "None" && propertyId !== 0;

      console.log("🔍 Counterparty validation check:", {
        transactionId,
        propertyId,
        hasTransactionId,
        hasPropertyId
      });

      if (!hasTransactionId || !hasPropertyId) {
        console.log("❌ Validation failed! Showing modal...");
        setModalMessage("Counterparties required Transaction and Property Details");
        setIsModalOpen(true);
        return;
      }
      console.log("✅ Counterparty has required Transaction and Property");
    }

    // Include diligence type in the payload so backend persists it on the
    // Entity record. Without this, Entity.Deligence_status stays NULL and the
    // backend's defensive 400 / N/A sync logic can't fire.
    const payload = ClientCounterpartyApiFactory({
      ...formData,
      diligenceStatus: sharedData.get("diligenceStatus") || "",
    });

    try {
      const response = await updateEntity(payload, requestId);
      const entityId = formData.entityId;

      if (!entityId) {
        throw new Error("Entity Id is missing in response.");
      }
  
      sharedData.set("entityId", entityId);
  
      if (response.ok) {
        console.log("✅ UpdateEntity Success", response.data);
      } else {
        console.warn("⚠️ Update Entity Error: ", response);
      }
  
      setModalMessage(<UpdatedSuccessfully page={"Client CounterParty"} />);
      setIsModalOpen(true);

      // Note: previously this branch force-saved Corporate Structure and
      // Management Data with status="Validated" whenever isRegulatoryListed
      // or isBillingEntityListed was Yes. That was a legacy hack to satisfy
      // the strict finalization gate when those sections didn't apply under
      // Simplified diligence. Backend now returns "N/A" by default for those
      // sections under Simplified, and the loosened checkFinalizeAvailability
      // accepts N/A — so this auto-save is no longer needed and was actively
      // polluting Final Review with stale "Validated" rows. Just navigate.
      const isClientCounterpartyCompleted = formData.entityStatus === "Validated" || formData.status === "Validated";
      const nextPath = getNextEnabledSection('/client-counter', {
        isEntityIdMissing: !entityId,
        isClientCounterpartyCompleted,
        searchParams
      });
      navigate(nextPath);
    } catch (error) {
      console.error("❌ Main update error:", error);
      setModalMessage(
        <>
          <strong>Error: {error.message || "Failed to update entity"}</strong>
        </>
      );
      setIsModalOpen(true);
    }
  }, [
    formData,
    requestId,
    searchParams,
    navigate,
    setModalMessage,
    updateEntity,
    isRegulatoryListed,
    isBillingEntityListed
  ]);
  
 
 
  const onValidate = useCallback(async (e) => {
    // Validate what is actually on screen. Reading the localStorage copy could
    // validate a stale snapshot that no longer matches the rendered form.
    const updatedFormData = { ...formData };
    if (updatedFormData.status === "Validated") { setModalMessage(<AlreadyValidated page={"Client CounterParty"} />); setIsModalOpen(true);  await updateRequestTable();  return; }


    const errors = validateClientCounterParty(updatedFormData);
    console.log("Validation Errors: ", errors);
    if (errors) {
      // TODO: Show errors in modal
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          <div style={{ "maxHeight": "200px", "overflow": "auto" }}>
            {Object.keys(errors).map((field) => (
              <div key={field}>
                <ul>
                  {errors[field].map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      )
      setIsModalOpen(true);
      return;
    }

    // Check if entity role is Counterparty and validate transaction/property requirement
    console.log("🔍 OnValidate - Checking Counterparty validation:", {
      entityType: updatedFormData.entityType,
      isCounterparty: updatedFormData.entityType === "Counterparty"
    });

    if (updatedFormData.entityType === "Counterparty") {
      const transactionId = sharedData.get("transactionId");
      const propertyId = sharedData.get("propertyId");

      const hasTransactionId = transactionId && transactionId !== "" && transactionId !== "None" && transactionId !== 0;
      const hasPropertyId = propertyId && propertyId !== "" && propertyId !== "None" && propertyId !== 0;

      console.log("🔍 Counterparty validation check (Validate & Lock):", {
        transactionId,
        propertyId,
        hasTransactionId,
        hasPropertyId
      });

      if (!hasTransactionId || !hasPropertyId) {
        console.log("❌ Validation failed! Showing modal...");
        setModalMessage("Counterparties required Transaction and Property Details");
        setIsModalOpen(true);
        return;
      }
      console.log("✅ Counterparty has required Transaction and Property");
    }

    if (!formData.companyType || !formData.countryOfIncorporation || formData.companyType === "None" || formData.countryOfIncorporation === "None") {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          Company Type
          <br />
          Country of Incorporation
        </>
      );
      setIsModalOpen(true);
      return;
    }
    if (!formData.diligenceStatus) {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>
            Diligence Type not found. Please Wait ...
          </strong>
        </>
      );
      setTimeout(async () => {
        setModalMessage(
          <>
            <h2 style={{ margin: "10px 0", textAlign: "center" }}>
              Validation Result
            </h2>
            <strong>
              Fetching Diligence Type...
              <ul>
                <li>Country of Incorporation: {formData.countryOfIncorporation}</li>
                <li>Company Type: {formData.companyType}</li>
              </ul>
            </strong>
          </>
        )
        if (formData.countryOfIncorporation) {
          const diligence = await clientCoutnerpartyService.getDiligenceType(
            formData.companyType,
            formData.countryOfIncorporation
          );
          if (diligence) {
            setDiligenceType(diligence);
            const privateEvent = { target: { name: "diligenceStatus", value: diligence } };
            console.log("privateEvent", privateEvent);
            updateFormData(privateEvent);
          }
        }
        setTimeout(() => {
          const diligenceType = JSON.parse(localStorage.getItem("clientFormData")).diligenceStatus;
          setModalMessage(
            <>
              <h2 style={{ margin: "10px 0", textAlign: "center" }}>
                Validation Result
              </h2>
              <strong>
                Diligence Type: {diligenceType}
              </strong>
              <p>Please click on Validate again</p>
            </>
          )
        }, 2000);
      }, 2000);
      setIsModalOpen(true);
      return;
    }
    try {
      await handleValidate(e);

      setModalMessage(<ValidatedSuccessfully page ={"Client CounterParty"} />);
      setIsModalOpen(true);

      // Refresh the page after a short delay to update the navigation tabs
      // and pick up the new "Validated" status for the view-mode banner.
      reloadAfterValidate(1500);

    } catch (error) {
      setModalMessage(
        <>
          <strong>Failed to update entity: ${error.message}</strong>
        </>
      );
      setIsModalOpen(true);
    }
  }, [formData, handleValidate, setModalMessage, updateFormData, validateClientCounterParty])

  return {
    deligenceStatus: currentStatus,
    isSelectorReadOnly,
    searchParams,
    compliantLetter,
    relianceFromThirdParty,
    modalMessage,
    location,
    hasUnsavedChanges,
    step,
    transactionId,
    transactionType,
    isModalOpen,
    isReadOnly,
    setIsReadOnly,
    formData,
    selectedOption,
    regulatoryBodies,
    companyType,
    exchanges,
    isEntityListed,
    isRegulatoryListed,
    isBillingEntityListed,
    existingEntity,
    countries,
    companyTypes,
    modalHeading,
    setIsModalOpen,
    sendMail,
    handleChange,
    handleRegulatoryChange,
    handleBillingEntityChange,
    handleentityChange,
    handleMoneyChange,
    handleCountryChange,
    handleUpdate,
    handleValidate,
    handleNext,
    handleEntityChanged,
    onValidate,
    setModalOpen,
    modalOpen,
    showAddressModal,
    validationResult,
    setShowAddressModal,
    pendingUpdatedData,
    isLoading,
    loadingMessage,
  }

};
